var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Aucun element") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Socle vide surmonte d'un point d'interrogation.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 256 176.4 L 438.9 282 L 256 387.6 L 73.1 282 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 202.8,
    x2: 118.8,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 290.3,
    y1: 222.6,
    x2: 153.1,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 324.6,
    y1: 242.4,
    x2: 187.4,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 358.9,
    y1: 262.2,
    x2: 221.7,
    y2: 341.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 393.2,
    y1: 282,
    x2: 256,
    y2: 361.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 202.8,
    x2: 393.2,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 221.7,
    y1: 222.6,
    x2: 358.9,
    y2: 301.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 187.4,
    y1: 242.4,
    x2: 324.6,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 153.1,
    y1: 262.2,
    x2: 290.3,
    y2: 341.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 118.8,
    y1: 282,
    x2: 256,
    y2: 361.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 353.2 270.4 L 256 326.6 L 256 338.1 L 353.2 282 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 158.8 270.4 L 256 326.6 L 256 338.1 L 158.8 282 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 256 214.3 L 353.2 270.4 L 256 326.6 L 158.8 270.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 225.9,
    x2: 256,
    y2: 214.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 225.9,
    x2: 353.2,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 225.9,
    x2: 158.8,
    y2: 282
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 256 214.3 L 353.2 270.4 L 256 326.6 L 158.8 270.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 353.2,
    y1: 270.4,
    x2: 353.2,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 256,
    y1: 326.6,
    x2: 256,
    y2: 338.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 158.8,
    y1: 270.4,
    x2: 158.8,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 353.2,
    y1: 282,
    x2: 256,
    y2: 338.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 256,
    y1: 338.1,
    x2: 158.8,
    y2: 282
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 256 231.8 L 321.7 269.8 L 256 307.7 L 190.3 269.8 Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "drift d2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "txta",
    x: 256,
    y: 173.1,
    fontSize: 140,
    textAnchor: "middle",
    dominantBaseline: "central",
    opacity: 0.9
  }, "?")), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 256,
    y1: 267.1,
    x2: 256,
    y2: 230.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 290.6,
    cy: 312.1,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 290.6,
    cy: 312.1,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d5",
    cx: 156.5,
    cy: 247.1,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 156.5,
    cy: 247.1,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d10",
    cx: 320.9,
    cy: 212.6,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 320.9,
    cy: 212.6,
    r: 3.6
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.351fe4d33feae47789a117dc18b69a45.svg";
export { ForwardRef as ReactComponent };